export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetError(context) {
      context.commit("setError", false);
    },
  },
  mutations: {
    setError(state, data) {
      return (state.data = data);
    },
  },
};
